<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import oresmitatil from "@/models/oresmitatil";
export default {
  mixins: [Api, Sabit, oresmitatil],
  page: {
    title: "Resmi Tatiller",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit,
  },
  data() {
    return {
      title: "Resmi Tatiller",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Sistem Yönetimi",
          href: "/",
        },
        {
          text: "Resmi Tatiller",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
    };
  },

  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "oresmitatil",
        Page: this.Page,
        Filter: "&Desc=",
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.oresmitatil
                    @click="(DataUpdate = oresmitatilData), (AddEdit = 'Add')">
                    <i class="mdi mdi-plus me-1"></i>
                    Yeni Kayıt Ekle
                  </button>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Adı</th>
                      <th>Gün</th>
                      <th>Özel</th>
                      <th>Yarım Gün</th>
                      <th class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          ">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Adi }}</th>
                      <td>
                        {{ formatDateTable(Data.Gun) }}
                      </td>
                      <td>

                        <i v-if="Data.Ozel" class="fas fas fa-check"></i>
                        <i v-else class="fas fas fa-times"></i>
                      </td>
                      <td>
                        <i v-if="Data.Yarimgun" class="fas fas fa-check"></i>
                        <i v-else class="fas fas fa-times"></i>
                      </td>
                      <td>
                        <div class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            <b-button v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.oresmitatil
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil"
                              @click="Delete('oresmitatil', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"   
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
